import React from 'react'
import PropTypes from "prop-types";
import "./css/coverBooksModal.css"; 

const CoverBooksModal = ({ coverBooks = [] }) => {
  return (
    <div
      className="modal fade"
      id="fullscreenCoverModal"
      tabIndex="-1"
      aria-labelledby="fullscreenModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body">

            <div className="container">
              <div className="row g-4 justify-content-center">

                {coverBooks.map((item) => (
                  <div
                    key={item.id}
                    className="col-12 col-md-6 col-lg-4 d-flex justify-content-center"
                  >
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="size-image-covermodal-hv"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CoverBooksModal.propTypes = {
  coverBooks: PropTypes.array,
};


export default CoverBooksModal
